import { Route, Routes } from "react-router-dom";
import { IRoute } from "./common/types";

import Login from "./pages/Login";
import Logout from "./pages/Logout";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

export const AppRoutes: IRoute[] = [
  {
    path: "/",
    ignoreLayout: true,
    component: <Login />,
  },
  {
    path: "/logout",
    ignoreLayout: true,
    component: <Logout />,
  },
  {
    path: "/forgot-password",
    ignoreLayout: true,
    component: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    ignoreLayout: true,
    component: <ResetPassword />,
  },
  // Anything else falls back to login rather than rendering a blank page — a
  // mistyped or truncated reset link is the likely way to get here.
  {
    path: "*",
    ignoreLayout: true,
    component: <Login />,
  },
];

export function AppRoute() {
  return (
    <Routes>
      {AppRoutes.map((route) => (
        <Route key={route.path} path={route.path} element={route.component} />
      ))}
    </Routes>
  );
}
